import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {ActivityStatus, CrudStatus} from '../../../../common/enums'
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store'
import {IUserDetails} from '../../../../models/user'
import {
  BM_EDIT_COMMENT_BY_FIELD,
  BM_MODULE_NAMESPACE
} from '../../../../store/building-monitor/bm-types.store'
import {IBMDetailViewModel} from '../../../../models/bm'
import {IBMMeetingDetailViewModel} from '../../../../models/bm/bm-meeting-detail.viewmodel'
import {BMCommentEditedViewModel} from '../../../../models/bm/bm-comment-edited.viewmodel'
import * as moment from 'moment'
import {Moment} from 'moment'

const UserStore = namespace(USER_MODULE_NAMESPACE)
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component({
  components: {
    'ticket-upload-buttons': async () => import('../../../ticket/components/ticket-modal-upload-buttons/TicketUploadButtons.vue')
  }
})
class BMCommentModalVertical extends Vue {
  dtRules: {
    descriptionRules?: any,
    nameRules?: any
  }
  dtSearchAllContact: boolean
  dtTemporaryParticipants: any[];
  dtParticipant: any
  dtLoadingComment: boolean
  sendDateTicket: boolean

  constructor () {
    super()
    this.dtRules = {}
    this.dtSearchAllContact = false
    this.dtTemporaryParticipants = []
    this.dtParticipant = null
    this.dtLoadingComment = false
    this.dtRules = {}
    this.sendDateTicket = false
  }

  @UserStore.Getter userInfo: IUserDetails;
  @BMStore.Getter bmCrudActionStatus: CrudStatus
  @BMStore.Getter bmCommentEdited: BMCommentEditedViewModel
  @BMStore.Getter bmSource: { activityStatus: ActivityStatus; detail: IBMDetailViewModel };
  @BMStore.Getter bmMeeting: { activityStatus: ActivityStatus; data: IBMMeetingDetailViewModel };

  @BMStore.Mutation(BM_EDIT_COMMENT_BY_FIELD)
  storeSetBMCommentEdited: (payload: { [key: string]: any }) => void

  @Prop({ default: false, type: [Boolean] })
  toUpdate: boolean
  @Prop({default: () => [], type: [Array]})
  attachments: any[];
  @Prop({ default: null, type: [Object] })
  commentSelected: { ticket: any }

  get lblSetting () {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/ticket').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get textConfigs () {
    return require('@/assets/json-resources/text-field-configs.json')
  }

  get displaySwitchCreateTicket (): boolean {
    return !this.toUpdate || this.commentSelected.ticket === null
  }

  get Subject (): string {
    return this.bmCommentEdited.subject
  }

  set Subject (value) {
    this.storeSetBMCommentEdited({subject: value})
  }

  get Description (): string {
    return this.bmCommentEdited.description
  }

  set Description (value) {
    this.storeSetBMCommentEdited({description: value})
  }

  get CreateTicket (): boolean {
    return this.bmCommentEdited.createTicket
  }

  set CreateTicket (value) {
    this.storeSetBMCommentEdited({createTicket: value})
  }

  get vAttachments () {
    return this.attachments
  }

  set vAttachments (value) {
    this.$emit('update:attachments', value)
  }

  get DateEndTicket () {
    return {
      startDate: this.bmCommentEdited.deadline || moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14) + '00:00.000Z'
    }
  }
  set DateEndTicket (dates: { startDate: string | Date | Moment }) {
    this.storeSetBMCommentEdited({
      deadline: dates.startDate.toString()
    })
  }

  created () {}

  mounted () {
    this.$nextTick(() => {
      if (this.toUpdate) {
        if (this.commentSelected.ticket) {
          if (this.commentSelected.ticket.deadline) {
            this.sendDateTicket = true
          }
        }
      }
    })

    this.dtRules = {
      nameRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.lblTicketName) })
      ],
      descriptionRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: 'Description', f: 'e' })
      ]
    }
  }

  getTicketRef (item) {
    return '#' + this.getPbType(item.pb_type) + item.ticket_number
  }

  getStateTicketColor (item) {
    switch (item.ticket.state) {
      case 'open':
      case 'reopen':
        return 'green'
      case 'in_progress':
        return 'orange'
      case 'close':
        return 'red'
      default:
        return 'primaryLight'
    }
  }

  getPbType (pbType) {
    switch (pbType) {
      case 'public':
        return 'S'
      case 'private':
        return 'G'
      case 'internal':
        return 'I'
    }
  }

  changeSwitchEndDate (val) {
    if (val) {
      // iCI
      if (this.toUpdate) {}
      else {
        this.DateEndTicket = { startDate: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14) + '00:00.000Z' }
      }
    } else {
      this.DateEndTicket = { startDate: '' }
    }
  }

  changeSwitchCreateTicket (val) {
    if (val) {
      if (this.toUpdate) {} else {}
    } else {
      this.sendDateTicket = false
    }
  }
}

export default BMCommentModalVertical



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-comment-modal-vertical/index.ts